import { useTagsHtmlETexto } from '@hooks/Analises/useManipulacaoDom';

const { obterTagsHtmlETextoEditorWp } = useTagsHtmlETexto();

const PATTERN = /[+*\n]|^\d+/g;

const typeAnalysisTitles = {
  grammatical: 'Correção Gramatical',
  subtitle: 'Distribuição de subtítulos',
  flesch: 'Facilidade de leitura Flesch',
  passive: 'Identificação de Voz Passiva',
  spelling: 'Correção Ortográfica',
  consecutiveWords: 'Palavras Consecutivas',
  sentenceLength: 'Tamanho da frase',
  blocksLength: 'Tamanho dos Blocos (entre os subtítulos)',
  comma: 'Uso de vírgula',
};

export function toggleMark(itemHtml, index, itemSelecionado, sentence, itemConteudo) {
  let title = itemSelecionado.titulo;
  const html = itemHtml.innerHTML;

  if (title === typeAnalysisTitles.blocksLength || title == typeAnalysisTitles.subtitle) {
    markBlockSize(index, sentence, itemHtml, itemConteudo);
  }

  /* if (title == typeAnalysisTitles.grammatical || title == typeAnalysisTitles.spelling && !html.includes(sentence + "-")) {
        
        // * Este if evita marcação de partes de strings que não sejam exatamente iguais a sentença.
        // * @exemplo `sentenca = We` não marcar o trecho `We` na string `Web`
         
        const index = item.innerHTML.indexOf(sentence)
        const matchedText = item.innerHTML.substring(index, index + sentence.length + 1)

        let regex = /[a-zA-ZÀ-ÿ]$/;
        if (!regex.test(matchedText[matchedText.length - 1]) || (regex.test(matchedText[matchedText.length - 1]) && matchedText == sentence))
            item.innerHTML = html.replaceAll(sentence, `<mark style="background-color:Tomato; color: #FFF;">${sentence}</mark>`)
    } */

  if (
    title == typeAnalysisTitles.flesch &&
    !html.includes(`<mark style="background-color:Tomato; color: #FFF;">${sentence}`)
  ) {
    const regex = new RegExp(`${sentence}(?![\\-\\/\\^"])`, 'g');
    itemHtml.innerHTML = html.replace(
      regex,
      `<mark style="background-color:Tomato; color: #FFF;">${sentence}</mark>`
    );
  }
  if (
    title !== typeAnalysisTitles.spelling &&
    title !== typeAnalysisTitles.grammatical &&
    title !== typeAnalysisTitles.blocksLength &&
    title !== typeAnalysisTitles.subtitle &&
    title !== typeAnalysisTitles.flesch
  ) {
    for (const frase of itemSelecionado.conteudo) {
      if (
        removerPropriedadesMutaveisWp(itemHtml.innerHTML) ==
          removerPropriedadesMutaveisWp(frase.bloco) &&
        itemHtml.innerHTML != frase.bloco
      )
        itemHtml.innerHTML = frase.bloco;

      if (
        !itemHtml.innerHTML.includes(frase.htmlMarcado) &&
        itemHtml.innerHTML.includes(frase.html)
      )
        itemHtml.innerHTML = itemHtml.innerHTML.replaceAll(frase.html, frase.htmlMarcado);
    }
  }
}

function markConsecutiveWords(sentence, item, paragrafo) {
  let newHtml = item.innerHTML;
  let regex = new RegExp(`(?![^<>]*>)\\b${sentence}\\b(.*?)`, 'gi');
  if (paragrafo.trim() == item.innerText.trim().replace(/(\r\n|\n|\r)/gm, '')) {
    newHtml = newHtml.replaceAll(
      regex,
      (match, p1) => `<mark style="background-color:Tomato; color: #FFF;">${match}</mark>`
    );
    item.innerHTML = newHtml;
  }
}

export function toggleConsecutiveWordsMark(item, initialSentence) {
  for (const word of initialSentence.palavras)
    markConsecutiveWords(word, item, initialSentence.paragrafo);
}

export function markBlockSize(index, sentence, item, itemConteudo) {
  const html = item.innerHTML;

  const newSentence = sentence;
  const htmlWithOutMarkTag = html.replaceAll(
    /<mark style="background-color:Tomato; color: #FFF;">(.*?)<\/mark>/g,
    '$1'
  );
  const markup = item.nodeName === 'UL' ? html : htmlWithOutMarkTag;
  if (
    removerPropriedadesMutaveisWp(markup) == removerPropriedadesMutaveisWp(newSentence) &&
    index == itemConteudo?.indexBloco
  )
    item.innerHTML = itemConteudo?.htmlMarcado?.includes(
      `<mark style="background-color:Tomato; color: #FFF;">`
    )
      ? itemConteudo?.htmlMarcado
      : `<mark style="background-color:Tomato; color: #FFF;">${newSentence}</mark>`;
}

export function tomark(itemSelecionado, switchClicked) {
  const content = obterTagsHtmlETextoEditorWp()?.childNodes || [];

  content.forEach(function (item, index) {
    const html = item.innerHTML;
    const htmlUnselected = html.replaceAll(
      /<mark style="background-color:Tomato; color: #FFF;">(.*?)<\/mark>/g,
      '$1'
    );
    item.innerHTML = item.innerHTML.replaceAll(html, htmlUnselected);
    if (switchClicked) {
      for (const initialSentence of itemSelecionado.conteudo) {
        if (itemSelecionado.titulo === typeAnalysisTitles.consecutiveWords)
          toggleConsecutiveWordsMark(item, initialSentence);

        if (itemSelecionado.titulo !== typeAnalysisTitles.consecutiveWords) {
          const sentence = verifySentenceIncluded(item, initialSentence, itemSelecionado.titulo);

          toggleMark(item, index, itemSelecionado, sentence, initialSentence);
        }
      }
    }
  });
}

function formatSentence(initialSentence) {
  let sentence = initialSentence?.ocorrencia ?? initialSentence?.html ?? initialSentence;

  const formattedSentence =
    typeof sentence === 'string' && sentence !== ''
      ? sentence[0].toUpperCase() + sentence.substring(1)
      : sentence;
  const cleanSentence = sentence
    .replace(PATTERN, ' ')
    .replace(/[ ]{2,}/g, ' ')
    .trim();

  return { sentence, cleanSentence, formattedSentence };
}

function verifySentenceIncluded(item, initialSentence, title) {
  const htmlNoMarked = item.innerHTML.replaceAll(
    /<mark style="background-color:Tomato; color: #FFF;">(.*?)<\/mark>/g,
    '$1'
  );

  const { sentence, cleanSentence, formattedSentence } = formatSentence(initialSentence);

  /* condition.includesSentence = htmlNoMarked.includes(sentence) ||
        htmlNoMarked.includes(cleanSentence) || htmlNoMarked.includes(formattedSentence)

    if (title == typeAnalysisTitles.blocksLength) {
        condition.includesSentenceAMP = (initialSentence?.frase?.split(" ").length > 2 &&
            item.textContent.includes(initialSentence?.frase)) &&
            item.innerHTML.includes("&amp;")
    } */

  return sentence;
}

const removerPropriedadesMutaveisWp = texto =>
  texto.replace(/\s(id|data-block|data-rich-text-format-boundary)="[^"]*"/gm, '');
